import styled from "styled-components";

export const LoaderInnerWrap = styled.div`
    display: flex;
    justify-content: center;
`
